import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/access";
import Loading from "@/atomic/atoms/Loading";
import Modal from "@/atomic/atoms/Modal";
import { Suspense } from "react";

function EyeIcon({ visible }: { visible: boolean }) {
  if (visible) {
    return (
      <svg width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="#909090" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
        <line x1="1" y1="1" x2="23" y2="23" />
      </svg>
    );
  }
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="#909090" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

function CheckIcon({ checked }: { checked: boolean }) {
  const color = checked ? "var(--color-success)" : "#C4C4C4";
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" className="shrink-0">
      <path
        d="M3.5 8.5L6.5 11.5L12.5 4.5"
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function RegisterAccessView({
  goBack,
  isDisabled,
  goToLogin,
  validatesPassword,
  validatesConfirmPassword,
  isVisiblePassword,
  isVisibleConfirmPassword,
  toggleIsVisiblePassword,
  toggleIsVisibleConfirmPassword,
  isLoading,
  error,
  errorPlate,
  success,
  register,
  handleSubmit,
  isVisibleModal,
  toggleModal,
}: PropsView) {
  return (
    <div className="h-full relative flex flex-col bg-white overflow-hidden">
      <Header title="Dados pessoais" hasLeftButton goBack={goBack} />

      <main className="flex-1 w-full flex flex-col items-center min-h-0 bg-background">
        <form
          className={`w-full max-w-[480px] flex-1 flex flex-col justify-between px-6 ${success ? "py-5" : "pt-6 pb-8"}`}
          onSubmit={handleSubmit}
        >
          {!success && (
            <div className="flex-1">
              <h2 className="text-text text-[22px] leading-tight font-bold font-primary tracking-tight">
                Defina uma nova senha
              </h2>
              <p className="mt-3 font-primary text-base text-tertiary leading-relaxed">
                Crie uma senha para acessar sua conta:
              </p>

              <div className="mt-8">
                <label className="text-sm text-text-secondary mb-1 block">
                  Nova senha
                </label>
                <div className="relative">
                  <input
                    {...register("password")}
                    required
                    type={isVisiblePassword ? "text" : "password"}
                    name="password"
                    placeholder="Sua senha"
                    className="text-base text-text w-full bg-white border border-border rounded-theme-medium px-4 h-14 pr-12 outline-none focus:border-primary transition-colors"
                  />
                  <button
                    type="button"
                    onClick={toggleIsVisiblePassword}
                    className="absolute right-4 top-1/2 -translate-y-1/2"
                  >
                    <EyeIcon visible={isVisiblePassword} />
                  </button>
                </div>

                <div className="mt-3 bg-white w-full rounded-theme-medium border border-border p-4 space-y-2">
                  {validatesPassword?.map((item, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <CheckIcon checked={item.success} />
                      <span
                        className={`text-sm ${
                          item.success
                            ? "text-success font-semibold"
                            : "text-text-secondary"
                        }`}
                      >
                        {item.text}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mt-6">
                <label className="text-sm text-text-secondary mb-1 block">
                  Confirme a senha
                </label>
                <div className="relative">
                  <input
                    {...register("confirmPassword")}
                    required
                    type={isVisibleConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    placeholder="Confirme a senha"
                    className="text-base text-text w-full bg-white border border-border rounded-theme-medium px-4 h-14 pr-12 outline-none focus:border-primary transition-colors"
                  />
                  <button
                    type="button"
                    onClick={toggleIsVisibleConfirmPassword}
                    className="absolute right-4 top-1/2 -translate-y-1/2"
                  >
                    <EyeIcon visible={isVisibleConfirmPassword} />
                  </button>
                </div>

                {validatesConfirmPassword && validatesConfirmPassword.length > 0 && (
                  <div className="mt-3 bg-white w-full rounded-theme-medium border border-border p-4 space-y-2">
                    {validatesConfirmPassword.map((item, index) => (
                      <div key={index} className="flex items-center gap-2">
                        <CheckIcon checked={item.success} />
                        <span
                          className={`text-sm ${
                            item.success
                              ? "text-success font-semibold"
                              : "text-text-secondary"
                          }`}
                        >
                          {item.text}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {success && (
            <div className="w-full flex-1 flex flex-col items-center justify-center gap-10">
              <div className="w-14 h-14 rounded-theme-large border border-[#24d696] flex items-center justify-center bg-[#e5f9f2]">
                <svg width={32} height={32} viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 13l4 4L19 7"
                    stroke="#24d696"
                    strokeWidth={2.5}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="flex flex-col gap-4 text-center w-full">
                <h1 className="text-text font-extrabold text-[30px] leading-[1.1] tracking-[-0.5px] font-primary">
                  Cadastro concluído
                </h1>
                <p className="text-[#525252] text-base leading-[1.4] font-primary">
                  Com o SuperApp Sem Parar, seu dia a dia fica mais simples.
                </p>
              </div>
            </div>
          )}

          {!success && (
            <button
              type="submit"
              disabled={isDisabled}
              className="w-full h-[52px] rounded-button text-white text-base font-semibold transition-colors mt-6 shrink-0"
              style={{
                backgroundColor: isDisabled
                  ? "var(--color-disabled)"
                  : "var(--color-primary)",
                color: isDisabled ? "var(--color-disabled-text)" : "#FFFFFF",
                cursor: isDisabled ? "not-allowed" : "pointer",
              }}
            >
              Continuar
            </button>
          )}

          {success && (
            <button
              type="button"
              onClick={goToLogin}
              className="w-full h-[60px] rounded-theme-large text-white text-base font-medium font-secondary tracking-[-0.4px] transition-colors shrink-0"
              style={{
                backgroundColor: "var(--color-primary)",
                cursor: "pointer",
              }}
            >
              Continuar
            </button>
          )}
        </form>
      </main>

      {error && isVisibleModal && (
        <Suspense fallback={null}>
          <Modal
            title="Ops!"
            message="Houve um problema ao registrar tuas informações, quer tentar novamente?"
            actionMessage="Tentar novamente"
            action={() => {
              toggleModal();
              handleSubmit();
            }}
            actionSecondMessage="Não!"
            actionSecond={toggleModal}
          />
        </Suspense>
      )}
      {errorPlate && isVisibleModal && (
        <Suspense fallback={null}>
          <Modal
            title="Ops!"
            message="Esta placa já está cadastrada. Realize o login para acessar as transações."
            actionMessage="Ok!"
            action={toggleModal}
          />
        </Suspense>
      )}
      {isLoading && <Loading />}
    </div>
  );
}
